import React from "react";
import { InvoiceView } from "./InvoiceView";
import {
  CrudlStatus,
  ToggleState,
  PageState
} from "../../common/config/AppConstants";
import { ViewState } from "../../common/config/AppConstants";
import { ValidateState } from "../../common/config/AppConstants";
import * as pr from "../../common/PrimeComponents";
import * as format from "../../common/FormatFunctions";

import { LoadScreen } from "../Common/LoadScreen";
import { ErrorScreen } from "../Common/ErrorScreen";

export class InvoiceController extends React.Component {
  state = {
    pageName: "InvoiceController",
    pageState: PageState.IDLE,
    editLoading: true,

    //DISPLAY STATES
    viewState: ViewState.TABLE,

    validateState: ValidateState.NONE,
    crudlState: CrudlStatus.LIST,
    menuState: [],

    // DATA TABLE
    expandedRows: null,
    tableColumns: [],
    columnOptions: [],
    rowCount: 10,
    settingsToggle: ToggleState.OFF,

    // DETAILS
    invoiceList: null,
    originalEditedInvoice: "",
    editedInvoice: null,

    hasOverlays: true
  };

  componentDidMount = async () => {
    this.initialDataRender();
  };

  componentDidCatch = (error, info) => {
    console.log("This went in here");

    //COMPONENT ISSUE CHECK IF THIS ERROR HANDLING IS CORRECT
    this.setError(false, "componentDidCatch", error);
  };

  initialDataRender = async () => {
    this.setViewModel();
    await this.setPageData();
  };

  setError = (critical, methodName, error) => {
    this.props.log.error(error.message);
    if (critical) {
      this.setCriticalError();
    } else {
      this.setStandardError();
    }
    this.props.viewModel.createException(
      error,
      this.state.pageName,
      methodName
    );
  };
  setStandardError = () => {
    //MORE CAN BE ADDED HERE AS APPROPRIATE
    this.showError("Invoice");
    this.setState({ pageState: PageState.IDLE });
  };
  setCriticalError = () => {
    //SET ERROR STATE OF PAGE
    this.setState({ pageState: PageState.ERROR });
  };

  setViewModel = () => {
    try {
      this.props.viewModel.updateState = this.updateState;
      this.props.viewModel.showError = this.showError;
      this.props.viewModel.showSuccess = this.showSuccess;
      this.props.viewModel.showEmpty = this.showEmpty;
    } catch (error) {
      this.setError(false, "setViewModel", error);
    }
  };

  setPageData = async () => {
    try {
      this.setState({ pageState: PageState.LOADING });

      this.menuState(CrudlStatus.LIST);

      this.setUpColumns();

      // SPECIFIC API CALLS GO HERE
      /* await this.props.viewModel.getInvoices(); */

      this.setState({
        pageState: PageState.IDLE
      });
    } catch (error) {
      this.setError(true, "setPageData", error);
    }
  };
  showError = (display, crudlStatus) => {
    try {
      this.props.feedback.showError(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showError", error);
    }
  };
  showSuccess = (display, crudlStatus) => {
    try {
      this.props.feedback.showSuccess(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showSuccess", error);
    }
  };
  showEmpty = display => {
    try {
      this.props.feedback.showEmpty(this.growl, display);
    } catch (error) {
      this.setError(false, "showEmpty", error);
    }
  };

  getStateValuesAsObject = () => {
    try {
      var externalObject = {};
      externalObject.invoiceBean = this.state.editedInvoice;

      return externalObject;
    } catch (error) {
      this.setError(false, "getStateValuesAsObject", error);
    }
  };

  updateBean = async (field, value) => {
    try {
      this.props.log.info(
        "Updating : [" + field + "] with value [" + value + "]"
      );
      await this.setState(prevState => ({
        editedInvoice: {
          // object that we want to update
          ...prevState.editedInvoice, // keep all other key-value pairs
          [field]: value
        }
      }));
    } catch (error) {
      this.setError(false, "updateBean", error);
    }
  };

  updateState = (key, value) => {
    try {
      this.setState({ [key]: value });
    } catch (error) {
      this.setError(false, "updateState", error);
    }
  };

  toggleOverlay = value => {
    try {
      this.props.log.info("Checking Overlays");
      if (this.state.hasOverlays) {
        this.props.log.info("Checking Overlays : true");
        if (format.isFunction(this.props.toggleTopbar)) {
          this.props.log.info("Checking Overlay Function : exists");
          this.props.toggleTopbar(value);
        }
      }
    } catch (error) {
      this.setError(false, "toggleOverlay", error);
    }
  };
  validateChanges = () => {
    try {
      if (this.state.editedInvoice === null) {
        this.discardChanges();
      } else {
        if (
          format.isJsonEqual(
            this.state.originalEditedInvoice,
            this.state.editedInvoice
          )
        ) {
          this.discardChanges();
        } else {
          this.setState({ validateState: ValidateState.CONFIRM });
        }
      }
    } catch (error) {
      this.setError(false, "validateChanges", error);
    }
  };

  discardChanges = () => {
    try {
      this.setState({
        viewState: ViewState.TABLE,
        toggleChangesMade: false,
        crudlState: CrudlStatus.LIST,
        selectedInvoice: null
      });
      this.toggleOverlay(ToggleState.ON);
      this.menuState(CrudlStatus.LIST);
    } catch (error) {
      this.setError(false, "discardChanges", error);
    }
  };

  checkRequiredFields = () => {
    try {
      if (format.isNotNull(this.state.editedInvoice)) {
        // ADD REQUIREDD FIELDS HERE AS APPROPRIATE
        return format.validateValues([this.state.editedInvoice.name]);
      } else {
        return true;
      }
    } catch (error) {
      this.setError(false, "checkRequiredFields", error);
    }
  };

  menuState = crudlStatus => {
    try {
      this.setState({
        menuState: pr.getBreadcrumbMenuState(
          crudlStatus,
          "Receivable",
          "#/receivables"
        )
      });
    } catch (error) {
      this.setError(false, "menuState", error);
    }
  };

  executeCrudl = async stayOnPage => {
    try {
      if (format.isNotNull(this.state.crudlState)) {
        this.props.log.info(
          "Executing " +
            this.state.crudlState.value +
            " Staying[" +
            stayOnPage +
            "]"
        );

        switch (this.state.crudlState) {
          case CrudlStatus.CREATE:
            await this.addInvoice(stayOnPage);
            break;
          case CrudlStatus.UPDATE:
            await this.updateInvoice(stayOnPage);
            break;
          case CrudlStatus.DELETE:
            await this.deleteInvoice();
            break;
          default:
            break;
        }
      }
    } catch (error) {
      this.setError(false, "executeCrudl", error);
    }
  };

  executeSetup = (requiredCrudlState, data) => {
    try {
      if (format.isNotNull(requiredCrudlState)) {
        this.props.log.info("Setting up " + requiredCrudlState.value);
        switch (requiredCrudlState) {
          case CrudlStatus.CREATE:
            this.createSetup();
            break;
          case CrudlStatus.UPDATE:
            this.updateSetup(data);
            break;
          case CrudlStatus.VIEW:
            this.viewSetup(data);
            break;
          case CrudlStatus.DELETE:
            this.deleteSetup(data);
            break;
          default:
            break;
        }
      }
    } catch (error) {
      this.setError(false, "executeSetup", error);
    }
  };

  setUpColumns = () => {
    let localCols = [];
    //SPECIFIC COLUMNS FOR TABLE
    localCols.push(pr.getTableColumn("invoiceSequenceNo", "Sequence No"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(
      pr.getTableColumn("customerDetails.businessName", "Customer")
    );
    localCols.push(pr.getTableColumn("purchaseOrderNo", "Purchase Order No"));
    localCols.push(
      pr.getTableColumn("clientReferenceNumber", "Client Reference")
    );
    localCols.push(pr.getTableColumn("shipTogether", "Ship Together"));
    localCols.push(pr.getTableColumn("status", "Status"));
    localCols.push(
      pr.getTableColumn("dateOrderReceivedToDisplay", "Order Date")
    );

    this.setState({ tableColumns: localCols });
    var colOptions = pr.getColumnOptions(localCols);
    this.setState({ columnOptions: colOptions });
  };

  columnToggle = event => {
    this.setState({ tableColumns: event.value });
  };

  createSetup = () => {
    window.scrollTo(0, 0);

    var data = {};
    data = this.additionalParseFunctions(data, CrudlStatus.CREATE);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.CREATE,
      editedInvoice: data,
      originalEditedInvoice: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.CREATE);
  };

  updateSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data, CrudlStatus.UPDATE);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.UPDATE,
      editedInvoice: data,
      originalEditedInvoice: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.UPDATE);
  };

  viewSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data, CrudlStatus.VIEW);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.VIEW,
      editedInvoice: data,
      originalEditedInvoice: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.VIEW);
  };

  deleteSetup = data => {
    data = this.additionalParseFunctions(data, CrudlStatus.DELETE);

    this.setState({
      crudlState: CrudlStatus.DELETE,
      editedInvoice: data,
      originalEditedInvoice: JSON.stringify(data),
      validateState: ValidateState.DELETE
    });
    this.menuState(CrudlStatus.DELETE);
  };

  additionalParseFunctions = (data, crudlState) => {
    //TODO if required
    switch (crudlState) {
      case CrudlStatus.CREATE:
        break;
      case CrudlStatus.UPDATE || CrudlStatus.VIEW:
        break;
      case CrudlStatus.DELETE:
        break;
      default:
        break;
    }
    this.props.log.info(data);
    return data;
  };

  addInvoice = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var invoiceResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.CREATE,
      stateVariables
    );

    if (invoiceResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateInvoiceList(
          invoiceResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentInvoice(
          invoiceResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };
  updateInvoice = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var invoiceResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.UPDATE,
      stateVariables
    );

    if (invoiceResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateInvoiceList(
          invoiceResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentInvoice(
          invoiceResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  deleteInvoice = async () => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var invoiceResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.DELETE,
      stateVariables
    );

    if (invoiceResponse.errorCode === 0) {
      await this.updateInvoiceList(
        invoiceResponse,
        CrudlStatus.DELETE,
        stateVariables
      );
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  updateInvoiceList = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    await this.props.viewModel.getInvoices();

    this.setState({
      viewState: ViewState.TABLE,
      crudlState: CrudlStatus.LIST,
      validateState: ValidateState.NONE,
      editedInvoice: null
    });

    this.toggleOverlay(ToggleState.ON);
    this.menuState(CrudlStatus.LIST);

    this.setState({ pageState: PageState.IDLE });
  };

  updateCurrentInvoice = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    var invoiceList = await this.props.viewModel.getInvoicesReturned();
    var invoice = {};
    if (format.isNotNull(invoiceList)) {
      invoiceList.forEach(element => {
        if (element.id === apiResponse.id) {
          invoice = format.deepCopy(element);
        }
      });
    }
    this.updateSetup(invoice);
    this.setState({ invoiceList: invoiceList });
    this.setState({ pageState: PageState.IDLE });
  };

  render() {
    return (
      <React.Fragment>
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />

        {/*VERY VERY BAD ERROS ONLY eg PAGE LOAD*/}
        {this.state.pageState === PageState.ERROR && (
          <ErrorScreen
            loading={this.state.pageState === PageState.LOADING}
            refresh={this.setPageData}
          />
        )}

        {this.state.pageState !== PageState.ERROR && (
          <InvoiceView
            //STATE + HELPER VALUES
            viewState={this.state.viewState}
            validateState={this.state.validateState}
            crudlState={this.state.crudlState}
            menuState={this.state.menuState}
            loading={this.state.pageState === PageState.LOADING}
            updateState={this.updateState}
            refresh={this.setPageData}
            //CARD SPECIFIC PROPS
            editedObject={this.state.editedInvoice}
            invoiceTypeOptions={this.state.invoiceTypeOptions}
            updateEdited={this.updateBean}
            validateChanges={this.validateChanges}
            discardChanges={this.discardChanges}
            checkRequiredFields={this.checkRequiredFields}
            crudlExecute={this.executeCrudl}
            //TABLE SPECIFIC PROPS
            crudlControl={this.executeSetup}
            invoiceList={this.state.invoiceList}
            expandedRows={this.state.expandedRows}
            tableColumns={this.state.tableColumns}
            columnOptions={this.state.columnOptions}
            columnToggle={this.columnToggle}
            tableReference={this.state.tableReference}
            rowCount={this.state.rowCount}
            settingsToggle={this.state.settingsToggle}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Invoice/InvoiceController.js